module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dashboard":"Dashboard","previousYear":"Previous year","taxReports":"Tax reports"},"fr":{"dashboard":"Vue d’ensemble","previousYear":"Année antérieure","taxReports":"Déclarations d’impôt"}}')
  delete Component.options._Ctor
}
